import React, { Component } from 'react';
import './AttractivenessWeight.css';
import _ from 'lodash';
import WeighTabs from './WeighTabs/WeighTabs';
import SelectedSegmentAttractivenessError from './SelectedSegmentAttractivenessError/SelectedSegmentAttractivenessError';

class AttractivenessWeight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createdData: false,
            editedData: false,
            createCriterialModal: false,
            tabs: [],
            attractivenessData: [],
            addedNewItemState: false,
            selectedSegmentAttractivenessError:false,
            weighting: [],
            segmentAttractivness: [],
            weightingNumber: [],
            weightingArrayIsEmpty: true,
            segmentAttractivnessIsEmpty: true,
            scoreNumber: 0,
            stepValidation: false,
            goNextStep: false,
        }
    }

    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: "attractivness"
        }
        let data = {
            projectId: this.props.projectId,
            type: "segmentation"
        }
        this.props.getCustomerGroup(data);
        this.props.getAttractivness(body);
    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.attractivnessData.Items && _.isEmpty(this.state.attractivenessData) ){

            if (!nextProps.attractivnessFetching && !_.isEmpty(nextProps.attractivnessData.Items)  &&  !_.isEmpty(nextProps.getCustomerGroupsData)) {
                let data =[]


                nextProps.attractivnessData.Items[0].attractivness.map(item=>{
                    if( item.important ){
                        data.push(item)
                    }
                })

                this.setState({
                    attractivenessData: data,
                    editedData : true, createdData : false,
                });

                let tabTitleArr = [];
                nextProps.attractivnessData.Items[0].attractivness.map(item=>{
                    let data = nextProps.getCustomerGroupsData.find(r => r.groupId === item.groupId);
                    tabTitleArr.push({
                        groupId: data.groupId,
                        groupName: data.groupName
                        //attractivnessId: uuidv1(),
                    });

                });

                let newData = _.uniqBy(tabTitleArr, 'groupId')
                newData.map(item=>{
                    this.state.tabs.push(item)
                })

            }

            if (!nextProps.attractivnessFetching && nextProps.attractivnessData.Items[0].weighting && !_.isEmpty(nextProps.attractivnessData.Items[0].weighting) && this.state.weightingArrayIsEmpty) {

                nextProps.attractivnessData.Items[0].weighting.map(item=>{
                    this.state.weighting.push(item)
                })

                this.setState({
                    weighting: this.state.weighting,
                    weightingArrayIsEmpty : false
                });
            }

            if (!nextProps.attractivnessFetching && nextProps.attractivnessData.Items[0].segmentAttractivness && !_.isEmpty(nextProps.attractivnessData.Items[0].segmentAttractivness) && this.state.segmentAttractivnessIsEmpty) {

                nextProps.attractivnessData.Items[0].segmentAttractivness.map(item=>{
                    this.state.segmentAttractivness.push(item)
                })

                this.setState({
                    segmentAttractivness: this.state.segmentAttractivness,
                    segmentAttractivnessIsEmpty : false
                }, () => this.segmentAttractivnessNumber());

            }

            if( _.isEmpty(nextProps.attractivnessData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }

        }

        if(!nextProps.craetCriteriaFetching && nextProps.craetCriteriaData && nextProps.craetCriteriaData.statusCode === 200 && this.props.stepState === 2 && this.state.goNextStep) {
            this.props.stateNext();
        }

    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    onChangeRatingValue = () => {

    }

    onChangeWeightingValue = (e, data) => {
        let oldItem;
        let newItem;
        let value = e.target.value;

        newItem = data.attractivnessId;
        let exist = this.state.weighting.find(r => r.attractivnessId === data.attractivnessId)
        if(exist){
            exist.value = value
        }else {
            this.state.weighting.push({
                attractivnessId: data.attractivnessId,
                value: value
            })
        }
        this.setState({ weighting: this.state.weighting }, () => this.weightingNumber() )
    }

    weightingNumber = () => {

    }

    segmentAttractivnessNumber = () => {

    }

    selectedSegmentAttractivenessErrorModa = () => {
        this.setState({  selectedSegmentAttractivenessError : !this.state.selectedSegmentAttractivenessError })
    }

    onNextButtonClick = () => {
        let stepValidation;
        let dataArr = 0;
        this.state.weighting.map(item=>{
            dataArr = dataArr + +item.value
        });

        let tabsNumber = [];
        this.state.weighting.map(item=>{
            let tabId =  this.state.attractivenessData.find(r => r.attractivnessId === item.attractivnessId)

            tabId ? tabsNumber.push({groupId: tabId.groupId}) : '';
        });

        let tabUniqData = _.uniqBy(tabsNumber, 'groupId')
        let k = tabUniqData.length

        let findZero = this.state.weighting.find(r => r.value === 0 || r.value === '0')
        if( (this.state.weighting.length === this.state.attractivenessData.length) && !findZero && (dataArr === 100 * k ) ){
            stepValidation = true;
        } else {
            stepValidation = false;
        }


        if(stepValidation){
            let body = {
                id: this.props.attractivnessData.Items[0].id,
                projectId: this.props.projectId,
                type: "attractivness",
                attractivness: this.state.attractivenessData,
                weighting: this.state.weighting
            }
            this.props.editCriteriaTab(body);
            this.setState({ goNextStep : true})
        }else {
            this.selectedSegmentAttractivenessErrorModa();
        }

    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-four arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-four arrow-step active-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-four arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-four arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>ATTRACTIVENESS</h5>
                      </div>
                    </div>
                    {!this.props.attractivnessFetching && !this.props.getCustomerGroupsFetching &&
                        <div className='row'>
                            <div className="col-md-12">
                                <div className='card'>
                                    <div className="card-header">
                                      <div className="col-md-12">
                                          <div className="criteria-title-box">
                                              <h5>Weigh Criteria of Attractiveness</h5>
                                              <span>Distribute 100 weighting points to illustrate the relative importance of each attractiveness criteria</span>
                                          </div>
                                      </div>
                                    </div>
                                    <div className='card-body'>
                                    { ( !this.props.attractivnessFetching && this.props.attractivnessData.Items ) &&
                                        <WeighTabs
                                            getAttractivness={this.props.getAttractivness}
                                            tabs={this.state.tabs}
                                            attractivenessData={this.state.attractivenessData}
                                            getSegmentsName={this.props.getSegmentsName}
                                            getSegmentFetching={this.props.getSegmentFetching}
                                            getSegmentData={this.props.getSegmentData}
                                            onChangeRatingValue={this.onChangeRatingValue}
                                            onChangeWeightingValue={this.onChangeWeightingValue}
                                            segmentAttractivness={this.state.segmentAttractivness}
                                            weighting={this.state.weighting}
                                            weightingNumber={this.state.weightingNumber}
                                            scoreNumber={this.state.scoreNumber}
                                            projectId={this.props.projectId}
                                            segmentAttractivness={this.state.segmentAttractivness}
                                            tabStep={this.props.tabStep}
                                            onTabChange={this.props.onTabChange}
                                        />
                                    }
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                        {/* <a href="/toolkit" className='btn empty-btn default'>Back</a> */}
                                        <div className='btn empty-btn default' onClick={() => this.props.stateBack()}>Back</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    { this.props.attractivnessFetching && this.props.getCustomerGroupsFetching &&
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className="card-body">
                                    {this.elementInfiniteLoad()}
                                </div>
                            </div>
                        </div>
                    }

                    { this.state.selectedSegmentAttractivenessError &&
                        <SelectedSegmentAttractivenessError
                            selectedSegmentAttractivenessErrorModal={this.selectedSegmentAttractivenessErrorModa}
                        />
                    }
                </div>
            </div>
        )
    }
}
export default (AttractivenessWeight);



// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/AttractivenessWeight/AttractivenessWeight.jsx